import { AuthenticatedHttp, GuestHttp } from '../../http/axios';

const isPresent = (value) => value !== null && value !== undefined && value !== '';

/**
 * Lista avaliações do produtor logado (e opcionalmente de produtos).
 * @param {Object} params
 * @param {number} [params.page=1]
 * @param {number} [params.limit=10]
 * @param {string|number} [params.productId]
 * @param {Array} [params.product]
 * @param {Object} [params.filters={}]
 * @returns {Promise<{ results: Array, count: number }>}
 */
export const getRatingsService = async ({
  page = 1,
  limit = 10,
  productId,
  product,
  filters = {},
}) => {
  const products = Array.isArray(product) ? product : [product ?? productId].filter(isPresent);

  const { data } = await AuthenticatedHttp.get('/ratings/list/', {
    params: {
      page,
      limit,
      ...(products.length > 0 && { product: products }),
      ...filters,
    },
  });

  return data;
};

/**
 * Valida o token do magic link de avaliação
 * @param {string} token - Token do magic link
 * @returns {Promise<{ valid: boolean, data?: Object, error?: string }>}
 * Response sucess: { valid: true, data: { token: string, payment_id: string } }
 * Response error: { valid: false, error: string }
 * 
 * IMPORTANTE: Para erros 409 (já usado) e 410 (expirado), o erro é propagado
 * para o hook tratar corretamente via onError, não via onSuccess.
 */
export const validateRatingToken = async (token) => {
  try {
    const { data } = await GuestHttp.get(`/ratings/validate/${token}/`);
    return data;
  } catch (error) {
    const status = error?.response?.status;
    
    // Para 409 (já usado) e 410 (expirado), propaga o erro para o hook tratar
    // Isso permite que o hook defina o estado correto (already_used ou expired)
    if (status === 409 || status === 410) {
      throw error; // Propaga o erro para o hook tratar no onError
    }
    
    // Para outros erros, retorna objeto com valid: false
    return {
      valid: false,
      error: error?.response?.data?.message || 'Token inválido',
    };
  }
};

/**
 * Envia a avaliação do cliente
 * @param {Object} payload
 * @param {string} payload.token - Token do magic link
 * @param {number} payload.rating - Nota (1 a 5)
 * @param {string} [payload.comment] - Comentário opcional
 * @returns {Promise<{ success: boolean, message: string }>}
 */
export const submitRating = async (payload) => {
  try {
    const { data } = await GuestHttp.post('/ratings/submit/', payload);
    return data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || 'Erro ao enviar avaliação',
    };
  }
};
